import EasyMDE from "easymde";

document.addEventListener("alpine:init", () => {
  Alpine.data("easyMDEController", (src, target, fileBaseUrl, onPostPage) => ({
    editorID: "",
    fileBaseUrl: "",

    setup() {
      this.fileBaseUrl = fileBaseUrl;
      let initialContent = document.getElementById(src).value;

      // if the editor has not been set up, set it up
      if (!this.editorID) {
        this.editorID = src;

        const editor = window.setupEasyMDE(
          target,
          this.fileBaseUrl,
          initialContent,
          this.$dispatch,
          onPostPage,
        );

        if (!window.editors) {
          window.editors = {};
        }
        window.editors[this.editorID] = editor;

        this.$store.postContent.setGetter(this.getContent.bind(this));
        this.$store.postContent.setEqualFunc(this.isCurrentContent.bind(this));
      }
    },

    getContent() {
      const editor = window.editors[this.editorID];
      return editor.value();
    },

    isCurrentContent(value) {
      const editor = window.editors[this.editorID];
      return value.replace(/\r\n/gm, "\n") == editor.value();
    },

    reload(value) {
      const editor = window.editors[this.editorID];
      let position = editor.codemirror.getCursor();
      editor.value(value);
      editor.codemirror.setCursor(position);
    },

    preview() {
      const editor = window.editors[this.editorID];
      editor.togglePreview();
      if (editor.isPreviewActive()) {
        window.Prism.highlightAll(true);
      }
    },

    insertFile(file) {
      const editor = window.editors[this.editorID];
      let cm = editor.codemirror;
      let cursor = cm.getCursor();

      const alt_text = file.alt_text || "";
      const url = file.insert_url || "";
      const title = file.title || "";
      const caption = file.caption.markdown || "";
      const lineNo = cursor.line;

      let prefix = "";
      if (cursor.ch > 0) {
        prefix = "\n\n";
      } else if (lineNo > cm.firstLine() && cm.getLine(lineNo - 1) != "") {
        prefix = "\n";
      }

      let suffix = "";
      if (cursor.ch < cm.getLine(lineNo).length) {
        suffix = "\n\n";
      } else if (lineNo < cm.lastLine() && cm.getLine(lineNo + 1) != "") {
        suffix = "\n";
      }

      let text = prefix + "![" + alt_text + "](" + url + ' "' + title + '")';
      if (caption) {
        text += "  \n" + caption;
      }
      text += suffix;

      cm.replaceSelection(text);

      cursor.ch += text.length;
      const lines = text.split(/\r\n|\r|\n/);
      if (lines.length > 1) {
        cursor.line += lines.length - 1;
        cursor.ch = lines[lines.length - 1].length;
      }

      cm.setCursor(cursor);
      cm.focus();

      this.$dispatch("notify", { msg: file.name + " added", type: "success" });
    },
  }));
});

function preview($dispatch) {
  return {
    name: "preview",
    action: function() {
      $dispatch("preview-post");
      window.Prism.highlightAll();
    },
    className: "fluid-width no-disable toolbar-preview",
    title: "Preview",
  };
}

function insertImage($dispatch) {
  return {
    name: "insertImage",
    action: function() {
      $dispatch("open-file-picker");
    },
    className: "fa fa-image",
    title: "Insert image",
  };
}

function save($dispatch) {
  return {
    name: "save",
    action: function() {
      $dispatch("save-post");
    },
    className: "fluid-width no-disable toolbar-save-post",
    title: "Save Post",
  };
}

function settings($dispatch) {
  return {
    name: "settings",
    action: function() {
      $dispatch("open-post-settings");
    },
    className: "fluid-width no-disable toolbar-settings",
    title: "Post Settings",
  };
}

window.setupEasyMDE = function(
  id,
  baseUrl,
  initialVal,
  $dispatch,
  onPostPage,
) {
  let toolbar = [
    "heading",
    "|",
    "bold",
    "italic",
    "strikethrough",
    "|",
    "quote",
    "ordered-list",
    "unordered-list",
    "|",
    "link",
    "code",
    "horizontal-rule",
    "clean-block",
    "|",
    insertImage($dispatch),
    "fullscreen",
    "|",
    preview($dispatch),
    "|",
  ];

  if (onPostPage) {
    toolbar.push(settings($dispatch), "|", save($dispatch), "|");
  }

  toolbar.push("guide");

  return new EasyMDE({
    element: document.getElementById(id),
    toolbar: toolbar,
    initialValue: initialVal,
    previewClass: ["max-w-none", "prose", "editor-preview"],
    sideBySideFullscreen: false,
    promptURLs: true,
    uploadImage: false,
    renderingConfig: {
      markedOptions: {
        baseUrl: baseUrl,
      },
    },
    indentWithTabs: false,
    tabSize: 4,
  });
};
